import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import type { TokenUsageBreakdown, TokenUsageCopy } from '@/frontend/pages/Dashboard/DigitalWorkers/types'
import UsageChannelIcon from './UsageChannelIcon'

interface Props {
  items: TokenUsageBreakdown[]
  copy: TokenUsageCopy
  showChannelIcons?: boolean
}

const TH_CLS = 'h-9 text-[10.5px] font-semibold uppercase tracking-[0.08em] text-faint-foreground'

export default function BreakdownList({ items, copy, showChannelIcons = false }: Props) {
  if (items.length === 0) {
    return <p className="py-8 text-center text-[13px] text-muted-foreground">{copy.no_dimension_data}</p>
  }

  return (
    <Table className="table-fixed text-[13px]">
      <TableHeader>
        <TableRow>
          <TableHead className={TH_CLS}>{copy.origin}</TableHead>
          <TableHead className={`w-28 text-right ${TH_CLS}`}>{copy.participation}</TableHead>
          <TableHead className={`w-10 ${TH_CLS}`}><span className="sr-only">{copy.actions}</span></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((item) => (
          <TableRow key={item.key}>
            <TableCell className="h-12 min-w-0 whitespace-normal">
              <div className="flex min-w-0 items-center gap-2.5">
                {showChannelIcons && (
                  <span className="flex size-7 shrink-0 items-center justify-center rounded-md border border-border bg-secondary/45">
                    <UsageChannelIcon channel={item.key} />
                  </span>
                )}
                <span className="truncate font-medium text-foreground">{item.label}</span>
              </div>
            </TableCell>
            <TableCell className="text-right text-[12px] font-medium tabular-nums text-muted-foreground">
              {item.share_label ?? '0'}%
            </TableCell>
            <TableCell aria-hidden="true" />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
